import type { FC } from 'react';
import { ConfirmationModal } from '@components/ConfirmationModal';

interface RemoveViewModalProps {
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const RemoveViewModal: FC<RemoveViewModalProps> = ({ isLoading, onCancel, onConfirm }) => (
  <ConfirmationModal
    data-testid="remove-view-modal"
    title="Remove this view?"
    description="Are you sure you would like to remove this view?"
    confirmLabel="Yes, remove view"
    isLoading={isLoading}
    onClose={onCancel}
    onConfirm={onConfirm}
  />
);
